import CheckboxList from './checkbox-list.vue';

/* istanbul ignore next */
CheckboxList.install = function(Vue) {
  Vue.component(CheckboxList.name, CheckboxList);
};

export default CheckboxList;
